<!-- essentails modal -->
<div class="modal fade smart_tagInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered" role="document">
	  <div class="modal-content infomodal">
		  <div class="kt-portlet kt-portlet--skin-solid">
			  <div class="kt-portlet__head kt-portlet__head--noborder">
				  <div class="kt-portlet__head-label">
					  <span class="kt-portlet__head-icon">
						  <img src="./assets/image/icons/algorithm/smart_tag.png">
					  </span>
					  <h3 class="kt-portlet__head-title">
						  Smart tags
					  </h3>
				  </div>
				  <div class="kt-portlet__head-toolbar">
					  <div class="kt-portlet__head-actions">
						  <a class="mr-1">
							  <img src="./assets/image/icons/help_icon.png">
						  </a>
						  <a class="ml-1" data-target="data_classification" data-dismiss="modal">
							  <img src="./assets/image/icons/close_icon.png">
						  </a>
					  </div>
				  </div>
			  </div>
			  <div class="kt-portlet__body">
				  Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
			  </div>
			  </div>
	  </div>
	</div>
  </div>
  <!-- end of essentials modal -->
  
  <!-- stamping modals -->
  <div class="modal fade data_classificationInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered" role="document">
	  <div class="modal-content infomodal">
		  <div class="kt-portlet kt-portlet--skin-solid">
			  <div class="kt-portlet__head kt-portlet__head--noborder">
				  <div class="kt-portlet__head-label">
					  <span class="kt-portlet__head-icon">
						  <img src="./assets/image/icons/algorithm/data_class.png">
					  </span>
					  <h3 class="kt-portlet__head-title">
						  Algo Classification
					  </h3>
				  </div>
				  <div class="kt-portlet__head-toolbar">
					  <div class="kt-portlet__head-actions">
						  <a class="mr-1">
							  <img src="./assets/image/icons/help_icon.png">
						  </a>
						  <a class="ml-1" data-target="data_classification" data-dismiss="modal">
							  <img src="./assets/image/icons/close_icon.png">
						  </a>
					  </div>
				  </div>
			  </div>
			  <div class="kt-portlet__body">
				  Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
			  </div>
			  </div>
	  </div>
	</div>
  </div>
  
  <div class="modal fade data_typeInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	  <div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content infomodal">
			<div class="kt-portlet kt-portlet--skin-solid">
				<div class="kt-portlet__head kt-portlet__head--noborder">
					<div class="kt-portlet__head-label">
						<span class="kt-portlet__head-icon">
							<img src="./assets/image/icons/algorithm/data_type.png">
						</span>
						<h3 class="kt-portlet__head-title">
							Data Type
						</h3>
					</div>
					<div class="kt-portlet__head-toolbar">
						<div class="kt-portlet__head-actions">
							<a class="mr-1">
								<img src="./assets/image/icons/help_icon.png">
							</a>
							<a class="ml-1" data-target="data_classification" data-dismiss="modal">
								<img src="./assets/image/icons/close_icon.png">
							</a>
						</div>
					</div>
				</div>
				<div class="kt-portlet__body">
					Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
				</div>
				</div>
		</div>
	  </div>
	</div>
  
	<div class="modal fade data_territoryInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	  <div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content infomodal">
			<div class="kt-portlet kt-portlet--skin-solid">
				<div class="kt-portlet__head kt-portlet__head--noborder">
					<div class="kt-portlet__head-label">
						<span class="kt-portlet__head-icon">
							<img src="./assets/image/icons/algorithm/data_territory.png">
						</span>
						<h3 class="kt-portlet__head-title">
							Algo Territory
						</h3>
					</div>
					<div class="kt-portlet__head-toolbar">
						<div class="kt-portlet__head-actions">
							<a class="mr-1">
								<img src="./assets/image/icons/help_icon.png">
							</a>
							<a class="ml-1" data-target="data_classification" data-dismiss="modal">
								<img src="./assets/image/icons/close_icon.png">
							</a>
						</div>
					</div>
				</div>
				<div class="kt-portlet__body">
					Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
				</div>
				</div>
		</div>
	  </div>
	</div>
  
	<div class="modal fade data_prodInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	  <div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content infomodal">
			<div class="kt-portlet kt-portlet--skin-solid">
				<div class="kt-portlet__head kt-portlet__head--noborder">
					<div class="kt-portlet__head-label">
						<span class="kt-portlet__head-icon">
							<img src="./assets/image/icons/algorithm/data_period.png">
						</span>
						<h3 class="kt-portlet__head-title">
							Collection Period 
						</h3>
					</div>
					<div class="kt-portlet__head-toolbar">
						<div class="kt-portlet__head-actions">
							<a class="mr-1">
								<img src="./assets/image/icons/help_icon.png">
							</a>
							<a class="ml-1" data-target="data_classification" data-dismiss="modal">
								<img src="./assets/image/icons/close_icon.png">
							</a>
						</div>
					</div>
				</div>
				<div class="kt-portlet__body">
					Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
				</div>
				</div>
		</div>
	  </div>
	</div>
	<div class="modal fade powerInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	  <div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content infomodal">
			<div class="kt-portlet kt-portlet--skin-solid">
				<div class="kt-portlet__head kt-portlet__head--noborder">
					<div class="kt-portlet__head-label">
						<span class="kt-portlet__head-icon">
							<img src="./assets/image/icons/algorithm/power.png">
						</span>
						<h3 class="kt-portlet__head-title">
							Power Stamping 
						</h3>
					</div>
					<div class="kt-portlet__head-toolbar">
						<div class="kt-portlet__head-actions">
							<a class="mr-1">
								<img src="./assets/image/icons/help_icon.png">
							</a>
							<a class="ml-1" data-target="data_classification" data-dismiss="modal">
								<img src="./assets/image/icons/close_icon.png">
							</a>
						</div>
					</div>
				</div>
				<div class="kt-portlet__body">
					Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
				</div>
				</div>
		</div>
	  </div>
	</div>
	<div class="modal fade demoInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	  <div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content infomodal">
			<div class="kt-portlet kt-portlet--skin-solid">
				<div class="kt-portlet__head kt-portlet__head--noborder">
					<div class="kt-portlet__head-label">
						<span class="kt-portlet__head-icon">
							<img src="./assets/image/icons/algorithm/link.png">
						</span>
						<h3 class="kt-portlet__head-title">
							Visual or Demo 
						</h3>
					</div>
					<div class="kt-portlet__head-toolbar">
						<div class="kt-portlet__head-actions">
							<a class="mr-1">
								<img src="./assets/image/icons/help_icon.png">
							</a>
							<a class="ml-1" data-target="data_classification" data-dismiss="modal">
								<img src="./assets/image/icons/close_icon.png">
							</a>
						</div>
					</div>
				</div>
				<div class="kt-portlet__body">
					Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
				</div>
				</div>
		</div>
	  </div>
	</div>
	<div class="modal fade metricesInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	  <div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content infomodal">
			<div class="kt-portlet kt-portlet--skin-solid">
				<div class="kt-portlet__head kt-portlet__head--noborder">
					<div class="kt-portlet__head-label">
						<span class="kt-portlet__head-icon">
							<img src="./assets/image/icons/algorithm/Quality.png">
						</span>
						<h3 class="kt-portlet__head-title">
							Metrices or Specs
						</h3>
					</div>
					<div class="kt-portlet__head-toolbar">
						<div class="kt-portlet__head-actions">
							<a class="mr-1">
								<img src="./assets/image/icons/help_icon.png">
							</a>
							<a class="ml-1" data-target="data_classification" data-dismiss="modal">
								<img src="./assets/image/icons/close_icon.png">
							</a>
						</div>
					</div>
				</div>
				<div class="kt-portlet__body">
					Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
				</div>
				</div>
		</div>
	  </div>
	</div>
  <!-- end of stamping modals -->
	
  
	<!--License Modal-->
  
	<div class="modal fade data_objectiveInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	  <div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content infomodal">
			<div class="kt-portlet kt-portlet--skin-solid">
				<div class="kt-portlet__head kt-portlet__head--noborder">
					<div class="kt-portlet__head-label">
						<span class="kt-portlet__head-icon">
							<img src="./assets/image/icons/algorithm/objective.png">
						</span>
						<h3 class="kt-portlet__head-title">
							Objective
						</h3>
					</div>
					<div class="kt-portlet__head-toolbar">
						<div class="kt-portlet__head-actions">
							<a class="mr-1">
								<img src="./assets/image/icons/help_icon.png">
							</a>
							<a class="ml-1" data-target="data_classification" data-dismiss="modal">
								<img src="./assets/image/icons/close_icon.png">
							</a>
						</div>
					</div>
				</div>
				<div class="kt-portlet__body">
					Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
				</div>
				</div>
		</div>
	  </div>
	</div>
  
	<div class="modal fade data_sourcingInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	  <div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content infomodal">
			<div class="kt-portlet kt-portlet--skin-solid">
				<div class="kt-portlet__head kt-portlet__head--noborder">
					<div class="kt-portlet__head-label">
						<span class="kt-portlet__head-icon">
							<img src="./assets/image/icons/algorithm/sourcing.png">
						</span>
						<h3 class="kt-portlet__head-title">
							Sourcing
						</h3>
					</div>
					<div class="kt-portlet__head-toolbar">
						<div class="kt-portlet__head-actions">
							<a class="mr-1">
								<img src="./assets/image/icons/help_icon.png">
							</a>
							<a class="ml-1" data-target="data_classification" data-dismiss="modal">
								<img src="./assets/image/icons/close_icon.png">
							</a>
						</div>
					</div>
				</div>
				<div class="kt-portlet__body">
					Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
				</div>
				</div>
		</div>
	  </div>
	</div>
  
	<div class="modal fade data_certiInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	  <div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content infomodal">
			<div class="kt-portlet kt-portlet--skin-solid">
				<div class="kt-portlet__head kt-portlet__head--noborder">
					<div class="kt-portlet__head-label">
						<span class="kt-portlet__head-icon">
							<img src="./assets/image/icons/algorithm/warranty.png">
						</span>
						<h3 class="kt-portlet__head-title">
							Certified Owner
						</h3>
					</div>
					<div class="kt-portlet__head-toolbar">
						<div class="kt-portlet__head-actions">
							<a class="mr-1">
								<img src="./assets/image/icons/help_icon.png">
							</a>
							<a class="ml-1" data-target="data_classification" data-dismiss="modal">
								<img src="./assets/image/icons/close_icon.png">
							</a>
						</div>
					</div>
				</div>
				<div class="kt-portlet__body">
					Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
				</div>
				</div>
		</div>
	  </div>
	</div>
  
  
	
	<div class="modal fade data_licensetypeInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	  <div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content infomodal">
			<div class="kt-portlet kt-portlet--skin-solid">
				<div class="kt-portlet__head kt-portlet__head--noborder">
					<div class="kt-portlet__head-label">
						<span class="kt-portlet__head-icon">
							<img src="./assets/image/icons/algorithm/license.png">
						</span>
						<h3 class="kt-portlet__head-title">
							License Type
						</h3>
					</div>
					<div class="kt-portlet__head-toolbar">
						<div class="kt-portlet__head-actions">
							<a class="mr-1">
								<img src="./assets/image/icons/help_icon.png">
							</a>
							<a class="ml-1" data-target="data_classification" data-dismiss="modal">
								<img src="./assets/image/icons/close_icon.png">
							</a>
						</div>
					</div>
				</div>
				<div class="kt-portlet__body">
					Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
				</div>
				</div>
		</div>
	  </div>
	</div>
  
  
	
	<div class="modal fade data_warrantyInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	  <div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content infomodal">
			<div class="kt-portlet kt-portlet--skin-solid">
				<div class="kt-portlet__head kt-portlet__head--noborder">
					<div class="kt-portlet__head-label">
						<span class="kt-portlet__head-icon">
							<img src="./assets/image/icons/algorithm/warranty.png">
						</span>
						<h3 class="kt-portlet__head-title">
							Warranty
						</h3>
					</div>
					<div class="kt-portlet__head-toolbar">
						<div class="kt-portlet__head-actions">
							<a class="mr-1">
								<img src="./assets/image/icons/help_icon.png">
							</a>
							<a class="ml-1" data-target="data_classification" data-dismiss="modal">
								<img src="./assets/image/icons/close_icon.png">
							</a>
						</div>
					</div>
				</div>
				<div class="kt-portlet__body">
					Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
				</div>
				</div>
		</div>
	  </div>
	</div>
	<!--End of license modal-->
  
  
  
  
	<!--storage modals-->
  
	
  <div class="modal fade data_sizeInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	  <div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content infomodal">
			<div class="kt-portlet kt-portlet--skin-solid">
				<div class="kt-portlet__head kt-portlet__head--noborder">
					<div class="kt-portlet__head-label">
						<span class="kt-portlet__head-icon">
							<img src="./assets/image/icons/algorithm/data_size.png">
						</span>
						<h3 class="kt-portlet__head-title">
							Algo Size
						</h3>
					</div>
					<div class="kt-portlet__head-toolbar">
						<div class="kt-portlet__head-actions">
							<a class="mr-1">
								<img src="./assets/image/icons/help_icon.png">
							</a>
							<a class="ml-1" data-target="data_classification" data-dismiss="modal">
								<img src="./assets/image/icons/close_icon.png">
							</a>
						</div>
					</div>
				</div>
				<div class="kt-portlet__body">
					Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
				</div>
				</div>
		</div>
	  </div>
	</div>
  
	<div class="modal fade data_flowInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	  <div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content infomodal">
			<div class="kt-portlet kt-portlet--skin-solid">
				<div class="kt-portlet__head kt-portlet__head--noborder">
					<div class="kt-portlet__head-label">
						<span class="kt-portlet__head-icon">
							<img src="./assets/image/icons/algorithm/data_flow.png">
						</span>
						<h3 class="kt-portlet__head-title">
							Algo Flow
						</h3>
					</div>
					<div class="kt-portlet__head-toolbar">
						<div class="kt-portlet__head-actions">
							<a class="mr-1">
								<img src="./assets/image/icons/help_icon.png">
							</a>
							<a class="ml-1" data-target="data_classification" data-dismiss="modal">
								<img src="./assets/image/icons/close_icon.png">
							</a>
						</div>
					</div>
				</div>
				<div class="kt-portlet__body">
					Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
				</div>
				</div>
		</div>
	  </div>
	</div>
  
	<div class="modal fade data_freqInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	  <div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content infomodal">
			<div class="kt-portlet kt-portlet--skin-solid">
				<div class="kt-portlet__head kt-portlet__head--noborder">
					<div class="kt-portlet__head-label">
						<span class="kt-portlet__head-icon">
							<img src="./assets/image/icons/algorithm/data_freq.png">
						</span>
						<h3 class="kt-portlet__head-title">
							Algo Frequency
						</h3>
					</div>
					<div class="kt-portlet__head-toolbar">
						<div class="kt-portlet__head-actions">
							<a class="mr-1">
								<img src="./assets/image/icons/help_icon.png">
							</a>
							<a class="ml-1" data-target="data_classification" data-dismiss="modal">
								<img src="./assets/image/icons/close_icon.png">
							</a>
						</div>
					</div>
				</div>
				<div class="kt-portlet__body">
					Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
				</div>
				</div>
		</div>
	  </div>
	</div>
  
	<div class="modal fade data_dictInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	  <div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content infomodal">
			<div class="kt-portlet kt-portlet--skin-solid">
				<div class="kt-portlet__head kt-portlet__head--noborder">
					<div class="kt-portlet__head-label">
						<span class="kt-portlet__head-icon">
							<img src="./assets/image/icons/algorithm/dictionary.png">
						</span>
						<h3 class="kt-portlet__head-title">
							Algo Dictionary
						</h3>
					</div>
					<div class="kt-portlet__head-toolbar">
						<div class="kt-portlet__head-actions">
							<a class="mr-1">
								<img src="./assets/image/icons/help_icon.png">
							</a>
							<a class="ml-1" data-target="data_classification" data-dismiss="modal">
								<img src="./assets/image/icons/close_icon.png">
							</a>
						</div>
					</div>
				</div>
				<div class="kt-portlet__body">
					Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
				</div>
				</div>
		</div>
	  </div>
	</div>
  
	<div class="modal fade data_previewInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	  <div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content infomodal">
			<div class="kt-portlet kt-portlet--skin-solid">
				<div class="kt-portlet__head kt-portlet__head--noborder">
					<div class="kt-portlet__head-label">
						<span class="kt-portlet__head-icon">
							<img src="./assets/image/icons/algorithm/preview.png">
						</span>
						<h3 class="kt-portlet__head-title">
							Algo Preview
						</h3>
					</div>
					<div class="kt-portlet__head-toolbar">
						<div class="kt-portlet__head-actions">
							<a class="mr-1">
								<img src="./assets/image/icons/help_icon.png">
							</a>
							<a class="ml-1" data-target="data_classification" data-dismiss="modal">
								<img src="./assets/image/icons/close_icon.png">
							</a>
						</div>
					</div>
				</div>
				<div class="kt-portlet__body">
					Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
				</div>
				</div>
		</div>
	  </div>
	</div>
  
	<div class="modal fade data_datasetInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	  <div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content infomodal">
			<div class="kt-portlet kt-portlet--skin-solid">
				<div class="kt-portlet__head kt-portlet__head--noborder">
					<div class="kt-portlet__head-label">
						<span class="kt-portlet__head-icon">
							<img src="./assets/image/icons/algorithm/dataset.png">
						</span>
						<h3 class="kt-portlet__head-title">
							Dataset
						</h3>
					</div>
					<div class="kt-portlet__head-toolbar">
						<div class="kt-portlet__head-actions">
							<a class="mr-1">
								<img src="./assets/image/icons/help_icon.png">
							</a>
							<a class="ml-1" data-target="data_classification" data-dismiss="modal">
								<img src="./assets/image/icons/close_icon.png">
							</a>
						</div>
					</div>
				</div>
				<div class="kt-portlet__body">
					Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
				</div>
				</div>
		</div>
	  </div>
	</div>
  
	<div class="modal fade data_metadataInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	  <div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content infomodal">
			<div class="kt-portlet kt-portlet--skin-solid">
				<div class="kt-portlet__head kt-portlet__head--noborder">
					<div class="kt-portlet__head-label">
						<span class="kt-portlet__head-icon">
							<img src="./assets/image/icons/algorithm/metadata.png">
						</span>
						<h3 class="kt-portlet__head-title">
							MetaData
						</h3>
					</div>
					<div class="kt-portlet__head-toolbar">
						<div class="kt-portlet__head-actions">
							<a class="mr-1">
								<img src="./assets/image/icons/help_icon.png">
							</a>
							<a class="ml-1" data-target="data_classification" data-dismiss="modal">
								<img src="./assets/image/icons/close_icon.png">
							</a>
						</div>
					</div>
				</div>
				<div class="kt-portlet__body">
					Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
				</div>
				</div>
		</div>
	  </div>
	</div>
	<div class="modal fade associationInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
	  <div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content infomodal">
			<div class="kt-portlet kt-portlet--skin-solid">
				<div class="kt-portlet__head kt-portlet__head--noborder">
					<div class="kt-portlet__head-label">
						<span class="kt-portlet__head-icon">
							<img src="./assets/image/icons/algorithm/sourcing.png">
						</span>
						<h3 class="kt-portlet__head-title">
							Entity Association
						</h3>
					</div>
					<div class="kt-portlet__head-toolbar">
						<div class="kt-portlet__head-actions">
							<a class="mr-1">
								<img src="./assets/image/icons/help_icon.png">
							</a>
							<a class="ml-1" data-target="data_classification" data-dismiss="modal">
								<img src="./assets/image/icons/close_icon.png">
							</a>
						</div>
					</div>
				</div>
				<div class="kt-portlet__body">
					Lorem Ipsum is simply dummy text of the printing and typesetting dummy text of the printing dummy text of the printing dummy text of the printing industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.
				</div>
				</div>
		</div>
	  </div>
	</div>
  
	<!--End of storage modals-->